import React, { Component } from 'react';

import { 
  NavLink,
  withRouter
} from 'react-router-dom';


import { Navigation, AnimatedRoutes, RouteTransition, Container, Content } from '../components';
import Routes from '../Routes.js';

class Layout extends Component {

  constructor(props) {
    super(props);

    this.state = {}

  }

  componentWillMount() {}

  componentDidMount() {}

  render() {
    
    return (

      <div className="Site-page">

         <div className="Site-home">
            <NavLink to={"/"}><div className="Site-icon Site-icon--home"><span>Home</span></div></NavLink>
        </div>
        
        <Container> 
        <div className="Site-head">

         
            
          <div className="Site-nav">

            <Navigation modifier={'head'} />
            
          </div>
        </div>
        </Container>

        <div className="Site-body">
  
          <Routes />
      
        </div>

        <div className="Site-contact">
          <Content html={"<p>Estate Ferlov Mancoba – Bredgade 63 – DK-1260 Copenhagen K – <a href='mailto:info@ferlovmancoba.com'>info@ferlovmancoba.com</a></p>"} modifier={'contact'} />
        </div>

        <div className="Site-foot">
          <Navigation modifier={'foot'} />
        </div>
        
    </div>
      
    );
  }
}

export default withRouter(Layout);



// WEBPACK FOOTER //
// ./src/js/templates/index.js